module.exports = __webpack_public_path__ + "img/icon-great.a9388e31.svg";